import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrGF: CultureInfo = {
  name: 'fr-GF',
  displayName: 'français (Guyane française)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-GF',
  parent: CultureInfoFr
};
